import { render, staticRenderFns } from "./SoMeFooter.vue?vue&type=template&id=68d60531&scoped=true"
import script from "./SoMeFooter.vue?vue&type=script&lang=js"
export * from "./SoMeFooter.vue?vue&type=script&lang=js"
import style0 from "./SoMeFooter.vue?vue&type=style&index=0&id=68d60531&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d60531",
  null
  
)

export default component.exports